import { PlaneTakeoff, Home, MapPin } from "lucide-react";
import { BRAND_COLORS, STATUS_COLORS, withAlpha } from "../../lib/bookingStatus";
import { DE_DATE } from "../../lib/dateFormat";

/**
 * Feb 2026 · Prominent card that shows whether the customer is currently
 * away (returns null if there's no absence data at all).
 *
 * Extrahiert aus `TeamCustomerDetail.jsx` (Refactor Feb 2026) —
 * Verhalten unverändert. Alle Farben aus dem zentralen Palette-Modul.
 */
export function AbsenceCard({ current, next }) {
  if (current) {
    return (
      <div
        className="border-l-4 p-6 md:p-7 shadow-sm"
        style={{
          borderLeftColor: STATUS_COLORS.red,
          background: `linear-gradient(135deg, ${withAlpha(STATUS_COLORS.red, 0.06)}, ${withAlpha(BRAND_COLORS.gold, 0.05)})`,
        }}
        data-testid="absence-current"
      >
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div className="min-w-0">
            <div className="inline-flex items-center gap-2 label-caps mb-2" style={{ color: STATUS_COLORS.red }}>
              <PlaneTakeoff className="w-3.5 h-3.5" strokeWidth={1.8} />
              Kunde aktuell abwesend
            </div>
            <div className="font-display text-2xl md:text-3xl text-navy leading-tight">
              {DE_DATE(current.from_date)} <span className="text-navy-dark/40 mx-2">→</span> {DE_DATE(current.to_date)}
            </div>
            {current.property_name && (
              <div className="mt-2 flex items-center gap-2 text-[13px] text-navy-dark/70">
                <MapPin className="w-3.5 h-3.5" strokeWidth={1.6} style={{ color: STATUS_COLORS.red }} />
                {current.property_name}
              </div>
            )}
          </div>
          <div className="text-right shrink-0">
            <div className="font-display text-3xl md:text-4xl" style={{ color: STATUS_COLORS.red }}>
              {current.days_remaining}
            </div>
            <div className="label-caps mt-1">Tage bis Rückreise</div>
          </div>
        </div>
      </div>
    );
  }
  if (next) {
    return (
      <div
        className="border-l-4 border-l-navy/25 bg-white p-6 md:p-7"
        data-testid="absence-next"
      >
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div>
            <div className="inline-flex items-center gap-2 label-caps mb-2" style={{ color: BRAND_COLORS.gold }}>
              <Home className="w-3.5 h-3.5" strokeWidth={1.8} />
              Kunde aktuell im Haus · nächste Abwesenheit
            </div>
            <div className="font-display text-xl md:text-2xl text-navy leading-tight">
              {DE_DATE(next.from_date)} <span className="text-navy-dark/40 mx-2">→</span> {DE_DATE(next.to_date)}
            </div>
            {next.property_name && (
              <div className="mt-2 text-[12.5px] text-navy-dark/70">{next.property_name}</div>
            )}
          </div>
          <div className="text-right shrink-0">
            <div className="font-display text-2xl md:text-3xl text-navy">{next.days_until}</div>
            <div className="label-caps mt-1">Tage bis Abreise</div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div
      className="border border-navy/10 bg-white p-6 flex items-center justify-between"
      data-testid="absence-none"
    >
      <div>
        <div className="label-caps mb-1">Aufenthalt</div>
        <div className="text-navy text-[15px]">Aktuell im Haus, keine Abreise geplant.</div>
      </div>
      <Home className="w-6 h-6 text-navy-dark/30" strokeWidth={1.4} />
    </div>
  );
}
